import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useIdentityContext } from 'react-netlify-identity/dist';
import { buttonSkinData, buttonBtnTypeData } from '@luigiclaudio/ga-baseline-ui/button';
import { FormSignUp } from '@luigiclaudio/ga-baseline-ui/auth';
import { useLoading } from '@luigiclaudio/ga-baseline-ui/helpers';
import useAuthFeedback from '../utils/useAuthFeedback';
import useAuthOneMoreStepMessage from '../utils/useAuthOneMoreStepMessage';

var AuthSignUp = function AuthSignUp(_ref) {
  var intl = _ref.intl,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      showHeading = _ref.showHeading;

  var _useState = useState(),
      errorMessage = _useState[0],
      setErrorMessage = _useState[1];

  var _useIdentityContext = useIdentityContext(),
      signupUser = _useIdentityContext.signupUser;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var _useAuthFeedback = useAuthFeedback(),
      handleFeedbackMessage = _useAuthFeedback.handleFeedbackMessage,
      feedbackMessage = _useAuthFeedback.feedbackMessage,
      hasForm = _useAuthFeedback.hasForm,
      hasFeedback = _useAuthFeedback.hasFeedback,
      hasOneMoreStep = _useAuthFeedback.hasOneMoreStep;

  var _useAuthOneMoreStepMe = useAuthOneMoreStepMessage(),
      handleOneMoreStepMessage = _useAuthOneMoreStepMe.handleOneMoreStepMessage,
      oneMoreStepMessage = _useAuthOneMoreStepMe.oneMoreStepMessage;

  var signUpCallback = function signUpCallback() {
    return handleOneMoreStepMessage({
      title: intl.formatMessage({
        id: 'auth.signUp.oneMoreStep.confirm.title'
      }),
      subtitle: intl.formatMessage({
        id: 'auth.signUp.oneMoreStep.confirm.subtitle'
      })
    });
  };

  var handleSignUp = function handleSignUp(_ref2) {
    var emailAddress = _ref2.emailAddress,
        username = _ref2.username,
        password = _ref2.password;
    load(signupUser(emailAddress, password, {
      data: 'Signed up via ga-auth',
      full_name: username
    }, false)).then(function () {
      handleFeedbackMessage({
        type: 'success',
        message: intl.formatMessage({
          id: 'auth.signUp.success.message'
        }),
        oneMoreStep: true,
        feedbackCallback: function feedbackCallback() {
          return signUpCallback();
        }
      });
    }).catch(function (error) {
      var errorData = error.json;
      var errorType = errorData.code,
          errorDescription = errorData.msg;
      setErrorMessage({
        errorType: errorType,
        errorDescription: errorDescription
      });
    });
  };

  return /*#__PURE__*/React.createElement(FormSignUp, {
    onSubmitSignUp: function onSubmitSignUp(values) {
      return handleSignUp(values);
    },
    errorMessage: errorMessage,
    isLoading: isLoading,
    inProp: hasForm,
    inPropFeedback: hasFeedback,
    feedbackType: feedbackMessage.type,
    feedbackMessage: feedbackMessage.message,
    oneMoreStep: hasOneMoreStep,
    oneMoreStepMessage: oneMoreStepMessage,
    buttonSkin: buttonSkin,
    buttonBtnType: buttonBtnType,
    showHeading: showHeading
  });
};

AuthSignUp.defaultProps = {
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  showHeading: true
};
export default injectIntl(AuthSignUp);